import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { DashboardAlert } from '@/types/dashboard';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  id: string | number;
  data: DashboardAlert;
};

type Response = DashboardAlert;

const validate = (id: string | number, data: DashboardAlert) => {
  if (id === null || id === undefined) {
    throw new Error('`id` is required');
  }
  if (!data.message) {
    throw new Error('`message` is required');
  }
};

export const updateDashboardAlert = async ({ id, data }: RequestParams, options: WriteRequestOptions): Promise<EndpointResponse<Response>> => {
  try {
    validate(id, data);

    const result = await scopedApi(GLOBAL_SCOPE).put<EndpointResponse<Response>>(`dashboard_alert/${id}`, data, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
